<!--
 * @Description:
 * @Date: 2021-11-11 18:16:01
-->
<template>
  <el-row type="flex" justify="start" align="middle">
    <el-checkbox
      style="margin-right: 30px"
      :disabled="!tableData.length"
      :value="selectedSize > 0"
      @change="change"
      :indeterminate="indeterminate"
    >
      结果全选
    </el-checkbox>
    <span>
      已选
      <span>{{ selectedSize || 0 }}</span>
      项， 批量操作：
    </span>
    <el-button
      :disabled="!actionEnabled"
      type="primary"
      size="small"
      @click="taskOverdue(2)"
    >
      批量过期
    </el-button>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'task-record-batch-action',
  computed: {
    ...mapState('dataAnalysis/taskOverdue', [
      'tableData',
      'pageTotal',
      'selectedSize',
      'isAll',
      'maxSelectedSize'
    ]),
    // ...mapState('dataAnalysis', ['projectDetail']),
    actionEnabled() {
      return this.selectedSize > 0;
    },
    indeterminate() {
      return this.selectedSize > 0 && this.selectedSize < this.pageTotal;
    }
  },
  methods: {
    change() {
      let isSelected = this.selectedSize > 0 ? false : true;
      isSelected = this.indeterminate ? true : isSelected;
      this.selectAll(isSelected).then(res => {
        const { list, total, query } = res;
        this.$parent.$parent.tableData = list;
        this.$parent.$parent.tableTotal = total;

        setTimeout(() => {
          for (const k in query) {
            this.$parent.$parent.$refs.baseForm.form[k] = query[k];
          }
        });
      });
    },
    ...mapActions('dataAnalysis/taskOverdue', ['selectAll', 'batchOverdue']),
    /**
     * 批量过期
     */
    async taskOverdue() {
      await this.batchOverdue();
      await this.$parent.$parent.tableSearch({ isSelected: '0' });
    }
  }
};
</script>

<style scoped></style>
